
const isHideFieldReport = (listHideFieldReport: EHideFieldReport[], field: EHideFieldReport) => {
    return listHideFieldReport.includes(field);
};

enum EHideFieldReport {
    PAYMENT_TYPE = 'PAYMENT_TYPE',
    COMMISSION = 'COMMISSION',
    TIP = 'TIP',
    SUPPLY_FEE = 'SUPPLY_FEE',
    TOTAL = 'TOTAL'
}

export { isHideFieldReport, EHideFieldReport };